<template>
    <div class="page-wrapper">
        <!-- <div class="page-top">
            <h3 class="welcome">综合体数字云仓欢迎您！</h3>
        </div> -->
        <div class="wating-area clearfix">
            <div class="box-wrap">
                <div class="box" @click="toOrderList(1)">
                    <div class="img-box">
                        <img src="../../../assets/home_waiting/ic_daixiadan.png">
                    </div>
                    <div class="cont">
                        <p class="text">待下单</p>
                        <strong class="num">{{homeData.reserveCountByDe || 0}}</strong>
                    </div>
                </div>
            </div>
            
            <div class="box-wrap">
                <div class="box" @click="toOrderList(2)">
                    <div class="img-box">
                        <img src="../../../assets/home_waiting/ic_daihexiao.png">
                    </div>
                    <div class="cont">
                        <p class="text">待核销订单</p>
                        <strong class="num">{{homeData.tobeEstablishDataInfoByDe || 0}}</strong>
                    </div>
                </div>
            </div>
            <div class="box-wrap">
                <div class="box" @click="toOrderList(2)">
                    <div class="img-box">
                        <img src="../../../assets/home_waiting/ic_daifukuanxiadan.png">
                    </div>
                    <div class="cont">
                        <p class="text">待付款下单订单</p>
                        <strong class="num">{{homeData.tobePaymentbillDataInfoByDe || 0}}</strong>
                    </div>
                </div>
            </div>
            <div class="box-wrap">
                <div class="box" @click="toOrderList(3)">
                    <div class="img-box">
                        <img src="../../../assets/home_waiting/ic_daituihuo.png">
                    </div>
                    <div class="cont">
                        <p class="text">待退货清算订单</p>
                        <strong class="num">{{homeData.refuseReturnDataInfoByDe || 0}}</strong>
                    </div>
                </div>
            </div>
            <div class="box-wrap">
                <div class="box" @click="toOrderList(3)">
                    <div class="img-box">
                        <img src="../../../assets/home_waiting/ic_daifukuandingsuan.png">
                    </div>
                    <div class="cont">
                        <p class="text">待付款清算订单</p>
                        <strong class="num">{{homeData.billdataInfoByLqDe || 0}}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-wrap clearfix">
            <div class="panel recent-data">
                <div class="header border-btm">
                    <div class="title"><i class="ic ic-jinqishuju"></i>近期数据概况</div>
                    <div class="date-picker">
                        <el-date-picker
                            v-model="dateDuring"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="selectDateDuring"
                        >
                        </el-date-picker>
                        <el-popover
                            placement="top-end"
                            title="提示"
                            width="200"
                            trigger="hover"
                            content="时间范围选择为空时，默认显示最近一周的数据">
                            <i slot="reference" class="el-icon-warning"></i>
                        </el-popover>
                    </div>
                </div>
                
                <div class="data-list clearfix" v-loading="dataLoading">
                    <div class="col col1">
                        <div class="line">新增锁仓订单数：{{homeData.reserveDataInfoByDe && homeData.reserveDataInfoByDe.totalOrderCount || 0}}笔</div>
                        <div class="line">新增锁仓款数：{{homeData.reserveSumItemByDe && homeData.reserveSumItemByDe.totalOrderCount || 0}}款</div>
                        <div class="line">新增锁仓件数：{{homeData.reserveDataInfoByDe && homeData.reserveDataInfoByDe.sumReserveQuantity || 0}}件</div>
                        <div class="line">新增锁仓总金额：{{homeData.reserveDataInfoByDe && homeData.reserveDataInfoByDe.sumPrice || 0}}元</div>
                    </div>
                    <div class="col col2">
                        <div class="line">新增锁仓转下单订单数：{{homeData.getPurchaseDataInfoByReseverOrderDe && homeData.getPurchaseDataInfoByReseverOrderDe.totalOrderCount || 0}}笔</div>
                        <div class="line">新增锁仓转下单款数：{{homeData.getPurchaseDataInfoByItemIdReseverOrderDe && homeData.getPurchaseDataInfoByItemIdReseverOrderDe.totalOrderCount || 0}}款</div>
                        <div class="line">新增锁仓转下单件数：{{homeData.getPurchaseDataInfoByReseverOrderDe && homeData.getPurchaseDataInfoByReseverOrderDe.sumOrdePurchaseQuantity || 0}}件</div>
                        <div class="line">新增锁仓转下单总金额：{{homeData.getPurchaseDataInfoByReseverOrderDe && homeData.getPurchaseDataInfoByReseverOrderDe.sumPrice || 0}}元</div>
                        <div class="line">新增直接下单订单数：{{homeData.getPurchaseDataInfoByOrderDe && homeData.getPurchaseDataInfoByOrderDe.totalOrderCount || 0}}笔</div>
                        <div class="line">新增直接下单款数：{{homeData.getPurchaseDataInfoByItemIdOrderDe && homeData.getPurchaseDataInfoByItemIdOrderDe.totalOrderCount || 0}}款</div>
                        <div class="line">新增直接下单件数：{{homeData.getPurchaseDataInfoByOrderDe && homeData.getPurchaseDataInfoByOrderDe.sumOrdePurchaseQuantity || 0}}件</div>
                        <div class="line">新增直接下单总金额：{{homeData.getPurchaseDataInfoByOrderDe && homeData.getPurchaseDataInfoByOrderDe.sumPrice || 0}}元</div>
                    </div>
                    <div class="col col3">
                        <div class="line">确认下单收款笔数：{{homeData.confirmPaymentDataInfoByDe && homeData.confirmPaymentDataInfoByDe.countNum || 0}}笔</div>
                        <div class="line">确认下单收款总金额：{{homeData.confirmPaymentDataInfoByDe && homeData.confirmPaymentDataInfoByDe.sumConfirmAmount || 0}}元</div>
                    </div>
                    <div class="col col4">
                        <div class="line">新增清算订单数：{{homeData.launchLqDataInfoByDe && homeData.launchLqDataInfoByDe.totalOrderCount || 0}}笔</div>
                        <div class="line">确认清算退货件数：{{homeData.returnQuantityByDe && homeData.returnQuantityByDe.sumReturnQuantity || 0}}件</div>
                        <div class="line">确认清算收款笔数：{{homeData.confirmlqPaymentDataInfoByDe && homeData.confirmlqPaymentDataInfoByDe.countNum || 0}}笔</div>
                        <div class="line">确认清算收款总金额：{{homeData.confirmlqPaymentDataInfoByDe && homeData.confirmlqPaymentDataInfoByDe.sumConfirmAmount || 0}}元</div>
                        <div class="line">完成清算订单数：{{homeData.finishLqDataInfoByDe && homeData.finishLqDataInfoByDe.totalOrderCount || 0}}笔</div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="all-data">
            <div class="panel">
                <div class="header">
                    <div class="title"><i class="ic ic-leijishuju"></i>累计数据</div>
                </div>
                <div class="data-list" style="padding-top: 4px;">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{ homeData.itemCountByOnByDe && homeData.itemCountByOnByDe.countItem || 0}}</strong>款</div>
                                <div class="label">在售商品总款数</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.totalStockByItemOnByDe && homeData.totalStockByItemOnByDe.totalStock || 0}}</strong>件</div>
                                <div class="label">在售商品总库存</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allReserveDataInfoByDe && homeData.allReserveDataInfoByDe.totalOrderCount || 0}}</strong>笔</div>
                                <div class="label">累计锁仓订单总数</div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allReserveDataInfoByDe && homeData.allReserveDataInfoByDe.sumReserveQuantity || 0}}</strong>件</div>
                                <div class="label">累计锁仓商品总数</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                        <div class="data-box">
                            <div class="value"><strong class="strong">{{homeData.allPurchaseDataInfoByDe && homeData.allPurchaseDataInfoByDe.totalOrderCount || 0 }}</strong>笔</div>
                            <div class="label">累计下单订单总数</div>
                        </div>
                        </el-col>

                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allPurchaseDataInfoByDe && homeData.allPurchaseDataInfoByDe.sumOrdePurchaseQuantity || 0 }}</strong>件</div>
                                <div class="label">累计下单商品总数</div>
                            </div>
                        </el-col>
                        
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allLqDataInfoByDe && homeData.allLqDataInfoByDe.totalOrderCount || 0 }}</strong>笔</div>
                                <div class="label">累计清算订单总数</div>
                            </div>
                        </el-col>
                        
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allLqDataInfoByItemIdByDe && homeData.allLqDataInfoByItemIdByDe.totalOrderCount || 0 }}</strong>件</div>
                                <div class="label">累计完成清算商品数</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allLqDataInfoByItemIdByDe && homeData.allLqDataInfoByItemIdByDe.totalOrderCount || 0 }}</strong>件</div>
                                <div class="label">累计确认退货数量</div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="data-box">
                                <div class="value"><strong class="strong">{{homeData.allConfirmPaymentDataInfoByDe && homeData.allConfirmPaymentDataInfoByDe.sumConfirmAmount || 0 }}</strong>元</div>
                                <div class="label">平台累计确认收款总金额</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    
        <check-password />
        
    </div>
</template>

<script>
import checkPassword from './check-password'
import { getIndexDataInfo } from '../../../api/supplier.js'
import { mapGetters } from 'vuex'
export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate: (e) => {
            let d = e.getTime()
            let now = new Date().getTime()
            return d > now
          }
        },
        dateDuring: '', // 时间间隔
        startTime: '',  // 开始时间
        endTime: '',    // 结束时间
        dataLoading: false,
        homeData: {  // 首页统计数据
        
        }
      }
    },
    components: {
        checkPassword
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
      this.getData();
    },
    methods: {
        getData() {
            this.dataLoading = true
            getIndexDataInfo({
                dealerUserId: this.userId,
                startTime: this.startTime,
                endTime: this.endTime
            }).then(res => {
                this.dataLoading = false
                console.log(res)
                if (res.errorCode == 200) {
                    this.homeData = res.data
                } else {
                    this.$message.error(res.errorMsg || '获取数据失败');
                }
            }).catch(err => {
                console.log(err)
                this.dataLoading = false
            })
        },
        selectDateDuring() {
            console.log(this.dateDuring)
            if (this.dateDuring) {
                this.startTime = this.dateDuring[0]
                this.endTime = this.dateDuring[1]
            } else {
                this.startTime = ''
                this.endTime = ''
            }
            this.getData()
        },
        toOrderList(type) {
            if (type === 1) {
                this.$router.push('/dealer/order/list-lock')
            } else if (type === 2) {
                this.$router.push('/dealer/order/list-take')
            } else if (type === 3) {
                this.$router.push('/dealer/order/list-clear')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 1000px;
    .page-top {
        height: 40px;
        .welcome {
            float: left;
            height:33px;
            font-size:26px;
            font-weight: bold;
            color:rgba(42,46,63,1);
            line-height:33px;
        }
    }
} 
.wating-area {
    margin: 0px -10px 0 -10px;
    height: 110px;
    .box-wrap {
        float: left;
        width: 20%;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .box {
        height: 110px;
        background:rgba(255,255,255,1);
        border-radius:2px;
        position: relative;
        box-sizing: border-box;
        padding: 28px 0 0 86px;
        cursor: pointer;
    }
    .img-box {
        position: absolute;
        left: 16px;
        top: 28px;
        width: 54px;
        height: 54px;
        img {
            width: 54px;
            height: 54px;
        }
    }
    .cont {
        .text {
            font-size:14px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:14px;
        }
        .num {
            display: block;
            margin-top: 16px;
            font-size:30px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:24px;
        }
    }
    
}
.panel-wrap {
  margin-top: 24px;
}
.panel {
  background: #fff;
  border-radius: 2px;
  .header {
    height: 60px;
    padding: 0 20px;
    font-size: 0;
    &.border-btm {
        border-bottom: 1px solid #e5e5e5;
    }
  }
  .title {
    font-size: 20px;
    line-height: 60px;
    display: inline-block;
    .ic {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-size: cover;
      background-repeat: no-repeat;
      vertical-align: text-top;
      margin-right: 8px;
    }
    .ic-jinqishuju {
      background-image: url('../../../assets/ic_jinqishuju.png');
    }
    .ic-leijishuju {
      background-image: url('../../../assets/ic_leijishuju.png');
    }
  }
  .date-picker {
    float: right;
    padding-top: 10px;
    
    .el-icon-warning {
      margin-left: 10px;
      font-size: 16px;
      color:#999;
      cursor: pointer;
    }

  }
  .data-list {
    padding: 20px;
    .col {
      width: 25%;
      float: left;
      &.col1 {
        width: 22%;
      }
      &.col2 {
        width: 28%;
      }
      &.col3 {
        width: 25%;
      }
      &.col4 {
        width: 25%;
      }
    }
    .line {
      height: 28px;
      font-size: 13px;
      line-height: 28px;
      color: #333;
      cursor: default;
      &:hover {
        font-weight: bold;
        transform: scale(1.02, 1.15);
      }
    }
    .data-box {
      margin-bottom: 24px;
      padding: 20px 0;
      text-align: center;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      &:hover {
        box-shadow: 0 0 20px #f1f1f1;
      }
      .label {
        height: 30px;
        font-size: 13px;
        color: #555;
        line-height: 30px;
      }
      .value {
        height: 40px;
        font-size: 13px;
        line-height: 40px;
        color: #333;
        .strong {
          color: #333;
          font-size: 24px;
          margin-right: 4px;
        }
      }
    }
  }
}
.all-data {
  margin-top: 24px;
}
</style>